"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStandaloneBinary = void 0;
const isStandaloneBinary = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Support for `pkg` with `--sea` flag, which uses `node --experimental-sea-mode` under the hood.
        const { isSea } = yield import('node:sea');
        return isSea();
    }
    catch (_a) {
        // Support for `pkg` without `--sea` flag, a.k.a. "Standard mode"
        // https://yao-pkg.github.io/pkg/guide/snapshot-fs#detecting-that-you-re-packaged
        if (process.pkg !== undefined) {
            return true;
        }
        // Older versions of Node.js do not have the `node:sea` module.
        return false;
    }
});
exports.isStandaloneBinary = isStandaloneBinary;
//# sourceMappingURL=is-standalone-binary.js.map